import { RequestError, RequestErrorArgs } from "./RequestError"

const IGNORED_PATHS = ["/projects", "/dashboard"]

export class UnauthorizedError extends RequestError {
  constructor(args: RequestErrorArgs) {
    super(args)
    this.name = "UnauthorizedError"
  }

  async notify() {
    if (
      !IGNORED_PATHS.some(path => this.path.toString().includes(path)) &&
      this.init?.method?.toUpperCase() === "GET"
    ) {
      super.notify()
    }
  }
}
